"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteTooltip = exports.StyledButton = exports.ButtonsRow = exports.TooltipContent = void 0;
const react_1 = __importDefault(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const styled_components_1 = __importDefault(require("styled-components"));
exports.TooltipContent = styled_components_1.default.div `
  text-align: left;
`;
exports.ButtonsRow = styled_components_1.default.div `
  display: grid;
  grid-template-columns: auto auto;
  gap: ${(0, wl_ui_kit_1.getSizeBy)(2)};
  margin-top: ${(0, wl_ui_kit_1.getSizeBy)(3)};
`;
exports.StyledButton = (0, styled_components_1.default)(wl_ui_kit_1.Button) `
  padding-right: ${(0, wl_ui_kit_1.getSizeBy)(2)};
  padding-left: ${(0, wl_ui_kit_1.getSizeBy)(2)};

  .text {
    font-weight: normal;
    white-space: nowrap;
  }
`;
const DeleteTooltip = ({ onClose, onDelete, deleteText, cancelText, children }) => {
    return (react_1.default.createElement(exports.TooltipContent, null, children !== null && children !== void 0 ? children : react_1.default.createElement(wl_ui_kit_1.Body2, null, "Are you sure?"),
        react_1.default.createElement(exports.ButtonsRow, null,
            react_1.default.createElement(exports.StyledButton, { text: cancelText !== null && cancelText !== void 0 ? cancelText : 'Cancel', onClick: onClose, variant: "text", size: "small" }),
            react_1.default.createElement(exports.StyledButton, { text: deleteText !== null && deleteText !== void 0 ? deleteText : 'Delete', onClick: onDelete, size: "small" }))));
};
exports.DeleteTooltip = DeleteTooltip;
//# sourceMappingURL=delete-tooltip.js.map